<template>
    <Main>
        <Header subTitle="Des solutions numériques sur-mesure" />

        <FullContainer>
            <h2>
                Notre expertise technologique
            </h2>
            <p>
                Les technologies mises en avant ici reflètent notre savoir-faire. Langages, frameworks, bases de données
                ou outils d'infrastructure : nous les maîtrisons pour concevoir, développer et faire évoluer vos projets
                web avec fiabilité et efficacité.
            </p>
        </FullContainer>

        <FullContainerWithMedia reversed>
            <h2>
                Le Front-End, la vitre de votre site
            </h2>
            <p>
                Le front-end, c'est ce que vos visiteurs voient et utilisent. Construit avec <strong>HTML</strong>,
                <strong>CSS</strong> et <strong>JavaScript</strong>, il rend votre site fluide, interactif et mieux
                référencé grâce à un code optimisé pour le <strong>SEO</strong>. De la maquette <strong>Figma</strong>
                aux animations et intégrations, il façonne l'expérience utilisateur.
            </p>
            <template #media>
                <div class="visual-container-multiple-media multiple-media-front-end">
                    <img src="~/assets/images/logos/js.png" alt="Javascript" />
                    <img src="~/assets/images/logos/html.png" alt="HTML" />
                    <img src="~/assets/images/logos/css.png" alt="CSS" />
                    <img src="~/assets/images/logos/figma.png" alt="Figma" />
                </div>
            </template>
        </FullContainerWithMedia>

        <FullContainerWithMedia>
            <h2>
                Le Back-End, le moteur de votre site
            </h2>
            <p>
                Le back-end gère les données, la sécurité et la logique de vos applications. Avec
                <strong>Python</strong>, <strong>Java</strong> et <strong>TypeScript</strong>, associés à des bases
                solides comme <strong>MySQL</strong> et <strong>PostgreSQL</strong>, nous construisons des systèmes
                fiables, performants et évolutifs.
            </p>
            <template #media>
                <div class="visual-container-multiple-media multiple-media-back-end">
                    <img src="~/assets/images/logos/typescript.png" alt="typescript" />
                    <img src="~/assets/images/logos/java.png" alt="java" />
                    <img src="~/assets/images/logos/mysql.png" alt="mysql" />
                    <img src="~/assets/images/logos/postgresql.png" alt="postgresql" />
                </div>
            </template>
        </FullContainerWithMedia>

        <FullContainerWithMedia>
            <h2>
                Des frameworks pour aller plus loin
            </h2>
            <p>
                Les frameworks offrent une structure efficace et accélèrent le développement. <strong>Django</strong>
                permet de créer des back-ends robustes et sécurisés, tandis que <strong>Vue.js</strong> apporte fluidité
                et modernité côté interface. Ensemble, ils assurent rapidité, clarté et évolutivité.
            </p>
            <template #media>
                <div class="visual-container-multiple-media multiple-media-frameworks">
                    <img src="~/assets/images/logos/vuejs.png" alt="vuejs" />
                    <img src="~/assets/images/logos/django.png" alt="Django" />
                </div>
            </template>
        </FullContainerWithMedia>

        <FullContainerWithMedia reversed>
            <h2>
                DevOps et hébergement, la stabilité au quotidien
            </h2>
            <p>
                Une infrastructure solide garantit un site fiable. Avec <strong>Docker</strong>, <strong>Linux</strong>
                et les pratiques de <strong>CI/CD</strong>, nous assurons des déploiements rapides et sécurisés. Chaque
                étape intègre la sécurité pour protéger vos données et maintenir vos services disponibles.
            </p>
            <template #media>
                <div class="visual-container-multiple-media multiple-media-devops">
                    <img src="~/assets/images/logos/docker.png" alt="docker" />
                    <img src="~/assets/images/logos/linux.png" alt="linux" />
                    <img src="~/assets/images/logos/github.png" alt="github" />
                </div>
            </template>
        </FullContainerWithMedia>

        <Tariffs>
            <h2>
                Nos Tarifs
            </h2>
            <p>
                Découvrez nos offres claires et adaptées à vos besoins, conçues pour vous offrir le meilleur rapport
                qualité-prix.
                Que vous soyez une petite entreprise ou une grande organisation, nous avons une solution pour vous.
            </p>
            <template #table>
                <table border="1" cellpadding="10" cellspacing="0"
                    style="border-collapse: collapse; width: 100%; text-align: center; font-family: Arial, sans-serif;">
                    <thead style="background-color: #f4f4f4;">
                        <tr>
                            <th>Option</th>
                            <th>Description</th>
                            <th>Prix à partir de (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Design personnalisé</td>
                            <td>Maquettes UX/UI, identité visuelle, responsive</td>
                            <td>500 €</td>
                        </tr>
                        <tr>
                            <td>Développement front-end</td>
                            <td>Intégration HTML, CSS, JS (site vitrine multi-pages)</td>
                            <td>800 €</td>
                        </tr>
                        <tr>
                            <td>Développement back-end</td>
                            <td>Fonctionnalités spécifiques (formulaires, base de données, espace client...)</td>
                            <td>1 200 €</td>
                        </tr>
                        <tr>
                            <td>CMS Headless</td>
                            <td>Architecture moderne (ex: Strapi, Sanity, Contentful) pour modifier le contenu
                                directement
                            </td>
                            <td>1 500 €</td>
                        </tr>
                        <tr>
                            <td>Hébergement</td>
                            <td>Serveur mutualisé ou dédié + SSL</td>
                            <td>10 €/mois</td>
                        </tr>
                        <tr>
                            <td>Maintenance / Support</td>
                            <td>Mises à jour, sauvegardes, correctifs</td>
                            <td>80 €/mois</td>
                        </tr>
                        <tr>
                            <td>Option QR Code</td>
                            <td>QR Code redirigeant vers le site ou une page spécifique</td>
                            <td>30 €</td>
                        </tr>
                        <tr style="background-color: #f0f8ff; font-weight: bold;">
                            <td>Pack premium</td>
                            <td>Design + Dev front & back + CMS headless</td>
                            <td>4 500 €</td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </Tariffs>
    </Main>
</template>

<script setup>
useSeoMeta({
    title: "Byte Hive — Expertise technique : front-end, back-end, DevOps & plus",
    description: "Découvrez notre savoir-faire chez Byte Hive : front-end réactif, back-end fiable, frameworks modernes, DevOps & hébergement sécurisé. Conception & évolution de projets web robustes.",
    ogTitle: "Byte Hive — Notre expertise technologique",
    ogDescription: "Front-end fluide, back-end solide, infrastructures stables. Chez Byte Hive, nous maîtrisons technologies & pratiques pour des sites web de qualité durable.",
    ogImage: "https://byte-hive.fr/byte-hive-og-image.png",
    ogUrl: "https://byte-hive.fr/expertise",
    ogType: "website"
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
